import React from "react";

const DescriptionEyeCheckupCamp = () => {
  return (
    <div className="eyecheckupcamp-container">
      <div className="eyecheckupcamp-hero">
        <h1 className="eyecheckupcamp-title">
         <span className="pinkhighlig">eye checkup camp</span> at your organization?
        </h1>
      </div>

      <div className="eyecheckupcamp-content">
        <p>
          With Dr Planete, it’s simple. You can post a request to invite an eye doctor (ophthalmologist) to your place for vision screening and eye care.
        </p>

        <p><strong>Eye checkups help in:</strong></p>
        <ul>
          <li>Spotting vision problems early</li>
          <li>Reducing eye strain from screens</li>
          <li>Teaching eye care tips</li>
          <li>Keeping students and employees healthy</li>
        </ul>

        <p><strong>How It Works:</strong></p>
        <ol>
          <li>Post your eye checkup request on Dr Planete.</li>
          <li>Eye doctors and hospitals who are members of Dr Planete will be notified.</li>
          <li>Interested professionals will contact you directly if they are available.</li>
        </ol>
      </div>
    </div>
  );
};

export default DescriptionEyeCheckupCamp;

// CSS styles (in the same file)
const style = document.createElement("style");
style.innerHTML = `
  .eyecheckupcamp-container {
    margin: 0 auto;
    width: 100%;
    font-family: 'Poppins', sans-serif;
  }

  .eyecheckupcamp-hero {
    background: black;
    text-align: center;
    padding: 2rem 1rem;
    border-radius: 0px;
    margin-bottom: 2rem;
  }

  .eyecheckupcamp-subtitle {
    color: black;
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 10px;
  }

  .eyecheckupcamp-title {
    font-size: 45px;
    color: white;
    font-weight: 700;
  }

  .pinkhighlig {
    color: #FF4081;
  }

  .eyecheckupcamp-content {
    font-size: 18px;
    line-height: 1.6;
    color: #333;
    padding: 0 1rem;
  }

  .eyecheckupcamp-content ul,
  .eyecheckupcamp-content ol {
    margin-left: 1.5rem;
    padding-left: 0.5rem;
  }

  .eyecheckupcamp-content li {
    margin-bottom: 0.5rem;
  }

  @media (max-width: 768px) {
    .eyecheckupcamp-title {
      font-size: 36px;
    }

    .eyecheckupcamp-subtitle {
      font-size: 20px;
    }

    .eyecheckupcamp-content {
      font-size: 19px;
    }
  }
`;
document.head.appendChild(style);
